import gql from 'graphql-tag';
import React from 'react';
import ErrorPage from '../ErrorPage';
import SystemMapPage from './SystemMapPage';

export const GET_SYSTEM_LOCATIONS = gql`
  {
    systems {
      id
      status
      area
      downtime
      project {
        code
        vessel
        owner {
          name
        }
      }
      location {
        timezone
        latitude
        longitude
      }
      alarmCategory
      alarms{
        category
        text
      }
    }
  }
`;

class SystemMap extends React.Component {

  state = {}

  static getDerivedStateFromError(error) {
    return {error};
  }

  setError = error => this.setState({error});
  render() {
    const {error} = this.state;
    if (error) {
      return <ErrorPage error={error} specific={error.specific}/>;
    }
    return (
      <SystemMapPage onError={this.setError}/>
    );
  }
}

export default SystemMap;
